<script lang="ts">
	const { tag = 'div', ...rest } = $props();
</script>

<svelte:element
	this={tag}
	class={[
		'my-1 h-4 w-20 self-center rounded bg-neutral-200',
		tag === 'span' ? 'inline-flex' : '',
		rest?.class,
	]}
></svelte:element>
